module.exports = __webpack_public_path__ + "static/media/icecream.51d78302.png";